module.exports = __webpack_public_path__ + "img/values.bed53957.svg";